import LastConfirmPage from './LastConfirmPage';

export default LastConfirmPage;
